
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { Get_DDL_M_Project_Grid_SelectDDLAPI, Get_DDL_M_Ward_Grid_SelectDDLAPI } from '../../Redux/DDLSlice'

export const ProjectNameGridDDL = (props) => {
    const {M_ProjectTypeID, ProjectName, setProjectName, rowData, APIFlag, IsPost } = props
    
    // console.log(rowData)

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { M_ProjectTypeID, APIFlag, UserID, token }
        dispatch(Get_DDL_M_Project_Grid_SelectDDLAPI({ data }))
    }, [IsPost, M_ProjectTypeID])

    const { ProjectNameDDLData } = useSelector(state => state.Get_DDL_M_Project_Grid_SelectDDLData)

    useEffect(() => {
        handleProjectNameDDL()
    }, [ProjectNameDDLData])

    const handleProjectNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (ProjectNameDDLData && ProjectNameDDLData.table && ProjectNameDDLData.table.length > 0) {
            let list = ProjectNameDDLData.table.map((item, index) => ({
                value: (item.m_ProjectID || item.projectID),
                label: item.projectName,
            }))

            setProjectName({
                DDL: list,
                ID: APIFlag === 'Update' ? (rowData.m_ProjectID || rowData.projectID) : 0,
                Label: APIFlag === 'Update' ? rowData.projectName : "Select...",
            })
        }
        else {
            setProjectName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Project Name </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ProjectName.ID, label: ProjectName.Label }}
                onChange={(e) => {
                    e ?
                        setProjectName({ ...ProjectName, ID: e.value, Label: e.label })
                        :
                        setProjectName({ ...ProjectName, ID: 0, Label: "Select..." })

                }}
                options={ProjectName.DDL}
            />
        </div>
    )
}